module.exports = __webpack_public_path__ + "static/media/1_9.0e3ba6b9.png";